import * as A from '../actions/helpActions';

export const 
setHelpMenuActiveKey = key => ({ type: A.SET_HELP_MENU_ACTIVE_KEY, payload: key }),
toggleHelpMenu = () => ({ type: A.TOGGLE_HELP_MENU }),
toggleHelpFaqModal = () => ({ type: A.TOGGLE_HELP_FAQ_MODAL });